export const examConstants = {
  GETALL_REQUEST: 'EXAMS_GETALL_REQUEST',
  GETALL_SUCCESS: 'EXAMS_GETALL_SUCCESS',
  GETALL_FAILURE: 'EXAMS_GETALL_FAILURE',

  GETBYID_REQUEST: 'EXAM_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'EXAM_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'EXAM_GETBYID_FAILURE',

  CREATE_REQUEST: 'EXAM_CREATE_REQUEST',
  CREATE_SUCCESS: 'EXAM_CREATE_SUCCESS',
  CREATE_FAILURE: 'EXAM_CREATE_FAILURE',

  UPDATE_REQUEST: 'EXAM_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'EXAM_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'EXAM_UPDATE_FAILURE',

  DELETE_REQUEST: 'EXAM_DELETE_REQUEST',
  DELETE_SUCCESS: 'EXAM_DELETE_SUCCESS',
  DELETE_FAILURE: 'EXAM_DELETE_FAILURE',

  ADD_QUESTIONS_REQUEST: 'EXAM_ADD_QUESTIONS_REQUEST',
  ADD_QUESTIONS_SUCCESS: 'EXAM_ADD_QUESTIONS_SUCCESS',
  ADD_QUESTIONS_FAILURE: 'EXAM_ADD_QUESTIONS_FAILURE',

  REMOVE_QUESTION_REQUEST: 'EXAM_REMOVE_QUESTION_REQUEST',
  REMOVE_QUESTION_SUCCESS: 'EXAM_REMOVE_QUESTION_SUCCESS',
  REMOVE_QUESTION_FAILURE: 'EXAM_REMOVE_QUESTION_FAILURE',

  DUPLICATE_REQUEST: 'EXAM_DUPLICATE_REQUEST',
  DUPLICATE_SUCCESS: 'EXAM_DUPLICATE_SUCCESS',
  DUPLICATE_FAILURE: 'EXAM_DUPLICATE_FAILURE',
};
